import React from 'react';
import { useNavigate } from 'react-router';
import './HomeLogo.scss';
import { SubdomainLogo } from '@bvt-shared/component/SubdomainLogo';

export default function HomeLogo() {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate({
      pathname: '/app/main/home',
    });
  };

  return (
    <div className='menu-bar__home-logo' onClick={handleBackToHome}>
      <SubdomainLogo context='navbar' />
    </div>
  );
}
